import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationInsightsService } from './core/services/application-insights.service';
import { ThemeSwitchService } from './core/services/theme/theme-switch.service';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { MvMsalService } from '@aot/host-app-widgets-demo';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'intelligent-advisor-config-ui';
  public authInitialized = false;
  private scope: string[] = [
    `${window.environmentVariableConfig.accentureADConfig.clientId}/access_as_user`,
];

  constructor(
    public router: Router,
    private applicationInsightsService: ApplicationInsightsService,public themeService:ThemeSwitchService,
    private authService : MsalService, private mvMsalService : MvMsalService) {
    localStorage.setItem('showSwitchThemeOption', 'Yes');
    this.themeService.initializeAppTheme();
  }

  ngOnInit(): void {
    localStorage.setItem("AppName","IntelligentAdvisorConfiguration");
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result) {
          this.mvMsalService.userAuthenticated(result);
        }else {
          // Check for active account on page refresh
          const activeAccount = this.authService.instance.getActiveAccount();
          if (activeAccount) {
            if(this.mvMsalService['isTokenExpired']()){
              this.authService.acquireTokenSilent({
                account: activeAccount,
                scopes: this.scope,
                forceRefresh: true
              }).subscribe({
                next: (freshResult: AuthenticationResult) => {
                  this.mvMsalService.userAuthenticated(freshResult);
                },
                error: (error) => {
                  console.error("Silent token acquisition failed", error);
                  this.authService.loginRedirect(); // fallback to interactive login
                }
              });
            }else{
              this.mvMsalService.userAuthenticated({account: activeAccount} as AuthenticationResult);
            }
             
          } else {
              // Handle unauthenticated state
              console.log("User is not authenticated.");
              this.navigatetoLogin();
              // Redirect to login or show login button
          }
      }
      this.authInitialized = true;
      },
      error: (error) => {console.error(error);
        this.authInitialized = true;}
    });
    window.addEventListener('navigateToLogin', (evt) => {
      this.navigatetoLogin()
    });

    window.addEventListener('toHome', (evt) => {
      this.navigatetoHome()
    });
    // Listening to event and calling the navigatetoHome method to redirect to the Home page
    window.addEventListener('toGlobe', (evt) => {
      this.navigatetoHome();
    });
  } 

  private navigatetoHome(){
    this.router.navigateByUrl('/home');
  }

  private navigatetoLogin(): void {
    this.router.navigateByUrl('/login');
  }
}
